/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SsoimageIdQueryResponse,
  GetApiV1SsoimageIdPathParams,
  GetApiV1SsoimageId401,
  GetApiV1SsoimageId404,
  GetApiV1SsoimageId500,
} from "../../types/SSOImageController/GetApiV1SsoimageId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SsoimageId } from "../../clients/SSOImageController/getApiV1SsoimageId.ts";

export const getApiV1SsoimageIdQueryKey = (
  id: GetApiV1SsoimageIdPathParams["id"],
) => [{ url: "/api/v1/ssoimage/:id", params: { id: id } }] as const;

export type GetApiV1SsoimageIdQueryKey = ReturnType<
  typeof getApiV1SsoimageIdQueryKey
>;

export function getApiV1SsoimageIdQueryOptions(
  id: GetApiV1SsoimageIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SsoimageIdQueryKey(id);
  return queryOptions<
    GetApiV1SsoimageIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageId401 | GetApiV1SsoimageId404 | GetApiV1SsoimageId500
    >,
    GetApiV1SsoimageIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SsoimageId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma imagem SSO ativa com seus idiomas pelo Id. **(Requer Authorization para autenticação)**
 * @summary Buscar imagem SSO por Id (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export function useGetApiV1SsoimageId<
  TData = GetApiV1SsoimageIdQueryResponse,
  TQueryData = GetApiV1SsoimageIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SsoimageIdQueryKey,
>(
  id: GetApiV1SsoimageIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SsoimageIdQueryResponse,
        ResponseErrorConfig<
          GetApiV1SsoimageId401 | GetApiV1SsoimageId404 | GetApiV1SsoimageId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1SsoimageIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1SsoimageIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1SsoimageId401 | GetApiV1SsoimageId404 | GetApiV1SsoimageId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
